import { Component, Inject, Input } from '@angular/core';
import { ClipboardServiceInterface } from '../../../services/clipboard/clipboard-service.interface';

@Component({
  selector: 'gtd-copy-referral-link',
  templateUrl: './copy-referral-link.component.html',
})
export class CopyReferralLinkComponent {
  @Input() isManager: boolean;
  @Input() public referralLink: string;

  isLoading: boolean;
  public showCopiedMessage = false;

  constructor(@Inject('ClipboardServiceInterface') private clipboardService: ClipboardServiceInterface) {}

  copy(): void {
    this.isLoading = true;
    this.clipboardService.copyFromContent(this.referralLink);
    this.showCopiedMessage = true;
    setTimeout(() => {
      this.showCopiedMessage = false;
      this.isLoading = false;
    }, 800);
  }
}
